import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import DeviceDetector from "../../DeviceDetector";

gsap.registerPlugin(ScrollTrigger);
export default class SayHelloHeading {
  constructor() {
    this.deviceDetector = new DeviceDetector();
    this.isMobile = this.deviceDetector.isMobile();

    this.stamp();
    this.heading();
  }

  stamp() {
    if (this.isMobile === false) {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ".circle-stamp",
          start: "top 100%",
          end: "bottom 0%",
          scrub: true,
          markers: false,
        },
      });

      tl.to(".circle-stamp", {
        rotate: `-90deg`,
      });
    }
  }

  heading() {
    if (this.isMobile === false) {
      const tl = new gsap.timeline({
        scrollTrigger: {
          trigger: ".say-hello__headings",
          start: "top 90%",
          end: "bottom 60%",
          scrub: true,
          markers: false,
        },
      });

      const elements = gsap.utils.toArray(".say-hello__headings > .heading h1");
      tl.fromTo(
        elements,
        { opacity: 0, x: window.outerWidth / 4 },
        { opacity: 1, x: 0, stagger: 0.15 }
      );
    }
  }
}
